import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { PayeePopupComponent } from '../../../../../shared/payee-popup/payee-popup.component';
import { PayeeFormFieldComponent } from '../../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeCopyFormFieldComponent } from '../../../../../shared/payee-form-fields/payee-copy-form-field/payee-copy-form-field.component';
import { PayeeButtonComponent } from '../../../../../shared/payee-buttons/payee-button/payee-button.component';
import { PayeeIconComponent } from '../../../../../shared/payee-icon/payee-icon.component';
import { TranslateModule } from '@ngx-translate/core';

export type StartWithTransferDialogData = {
  transfer_amount: number;
  currency_iso: string;
  reference: string;
};

@Component({
  selector: 'app-start-with-transfer-dialog',
  templateUrl: './start-with-transfer-dialog.component.html',
  styleUrls: ['./start-with-transfer-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeCopyFormFieldComponent,
    PayeeButtonComponent,
    MatDialogClose,
    PayeeIconComponent,
    TranslateModule,
  ],
})
export class StartWithTransferDialogComponent {
  private fb = inject(FormBuilder);
  data = inject<StartWithTransferDialogData>(MAT_DIALOG_DATA);

  readonly form = this.fb.group({
    transfer_amount: this.fb.control(this.data.transfer_amount, {
      nonNullable: true,
    }),
    currency_iso: this.fb.control(this.data.currency_iso, {
      nonNullable: true,
    }),
    account_holder_name: this.fb.control('Legal Labs Kft.', {
      nonNullable: true,
    }),
    account_number: this.fb.control('12600016-19259526-84463815', {
      nonNullable: true,
    }),
    reference: this.fb.control(this.data.reference, { nonNullable: true }),
  });
}
